export const DEFAULT_ROOT = '.bemedev';
export const JSON_PATH = '.bemedev.json';

export const config = {
  json: JSON_PATH,
  root: DEFAULT_ROOT,
};
